import { iconsAb, imagesAb, imagesBcp, iconsBcp, animationsBcp, animationsAb } from '../assets';
import { AppTheme } from './types';

export const appThemeAb: AppTheme = {
	images: {
		success: {
			src: imagesAb.headerSuccess,
			height: '150px',
			width: '200px',
		},
		sliderHandler: {
			src: iconsAb.sliderHandler,
			height: '22px',
			width: '11px',
		},
		mbcpLogo: { src: imagesBcp.mbcpLogo, height: '56px', width: '56px' },
		chooseAmount: { src: imagesBcp.chooseAmount, height: '80px', width: '80px' },
		chevronRight: { src: imagesBcp.chevronRight, height: '22.5px', width: '22.5px' },
		abLogo: { src: imagesAb.abLogo, height: '96px', width: '96px' },
	},
	colors: {
		profileBackground: '#f1f2f4',
	},
	animations: {
		loader: {
			src: animationsAb.loader,
			height: '120px',
			width: '120px',
		},
	},
};

export const appThemeBcp: AppTheme = {
	images: {
		success: {
			src: imagesBcp.success,
			height: '100px',
			width: '100px',
		},
		sliderHandler: {
			src: iconsBcp.sliderHandler,
			height: '22px',
			width: '11px',
		},
		mbcpLogo: { src: imagesBcp.mbcpLogo, height: '56px', width: '56px' },
		chooseAmount: { src: imagesBcp.chooseAmount, height: '80px', width: '80px' },
		chevronRight: { src: imagesBcp.chevronRight, height: '22.5px', width: '22.5px' },
		abLogo: { src: imagesAb.abLogo, height: '96px', width: '96px' },
	},
	colors: {
		profileBackground: '#d1005d',
	},
	animations: {
		loader: {
			src: animationsBcp.loader,
			height: '120px',
			width: '120px',
		},
	},
};
